import { h } from "preact";
import { useLocationFormStorage } from "./locationFormContext";

export function GuestInput() {
  const {
    adults,
    kids,
    dogs,
    setAdults,
    setKids,
    setDogs,
    setShowGuestOverlay,
  } = useLocationFormStorage();

  const isHU = document?.body?.classList?.contains("theme-hu") ?? false;

  return (
    <div
      id="locationFormGuestLocationInput"
      className="col-span-1 md:col-span-1"
    >
      <div class="inputfield__inputcontainer">
        <button
          id="toggleGuests"
          class="inputfield__inputcontainer-control pl-8"
          type="button"
          onClick={() => setShowGuestOverlay(true)}
        >
          <span
            class="text-sm scale-85 absolute transition-all duration-150 ease-in-out left-8 top-2 text-brandcopy-800 font-extrabold w-full text-left"
            style="transform-origin: top left;"
          >
            {global.Translator.trans("locationform.guest_select", {}, "js")}
          </span>

          <span class="flex gap-2 items-start">
            <span>
              {adults + kids}{" "}
              {global.Translator.trans("locationform.guests", {}, "js")}
            </span>
            {dogs > 0 && (
              <span>
                | {dogs}{" "}
                {global.Translator.trans("locationform.dogs", {}, "js")}
              </span>
            )}
          </span>
          {isHU ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              height="24"
              width="24"
              className="absolute left-2.5 w-4 h-4 block top-5.5 hover:text-brandcopy-500"
            >
              <path
                d="M0 9.76a3 4.46 0 1 0 6 0 3 4.46 0 1 0 -6 0"
                fill="currentColor"
                strokeWidth="1"
              />
              <path
                d="M8.77 8.19C10.6 8.19 11.54 6 11.46 4c-0.09 -2.3 -1.36 -4 -2.93 -4 -1.78 0.07 -2.69 2.27 -2.61 4.21 0.08 2.2 1.31 3.98 2.85 3.98Z"
                fill="currentColor"
                strokeWidth="1"
              />
              <path
                d="M18 9.76a3 4.46 0 1 0 6 0 3 4.46 0 1 0 -6 0"
                fill="currentColor"
                strokeWidth="1"
              />
              <path
                d="M15.23 8.19c1.54 0 2.76 -1.78 2.85 -4 0.07 -1.87 -0.81 -4.12 -2.61 -4.19 -1.57 0 -2.84 1.69 -2.93 4 -0.08 1.92 0.85 4.19 2.69 4.19Z"
                fill="currentColor"
                strokeWidth="1"
              />
              <path
                d="M15.9 13.68c-0.4 -2 -1.64 -4.14 -3.9 -4.14s-3.5 2.14 -3.9 4.14a4.69 4.69 0 0 1 -1.34 1.91c-1 1 -2.08 2.2 -2.08 4 0 4 5.94 4.43 7.32 4.43 3.53 0 7.32 -1.39 7.32 -4.43 0 -1.78 -1.1 -2.95 -2.08 -4a4.69 4.69 0 0 1 -1.34 -1.91Z"
                fill="currentColor"
                strokeWidth="1"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              height="24"
              width="24"
              className="absolute left-2.5 w-4 h-4 block top-5.5 hover:text-brandcopy-500"
            >
              <path
                d="M14.23 14.1v3.47a2 2 0 0 1 -0.35 1.11 0.22 0.22 0 0 0 0 0.16l0.39 4.71a0.49 0.49 0 0 0 0.49 0.45h4a0.49 0.49 0 0 0 0.49 -0.45l0.44 -5.26a0.25 0.25 0 0 1 0.25 -0.23h1.79a0.49 0.49 0 0 0 0.49 -0.49V14.1a5.43 5.43 0 0 0 -9 -4.1 0.26 0.26 0 0 0 -0.05 0.32 6.84 6.84 0 0 1 1.06 3.78Z"
                fill="currentColor"
                strokeWidth="1"
              />
              <path
                d="M2.35 18.06h1.79a0.25 0.25 0 0 1 0.25 0.23l0.44 5.26a0.49 0.49 0 0 0 0.49 0.45h4a0.49 0.49 0 0 0 0.49 -0.45l0.44 -5.26a0.25 0.25 0 0 1 0.25 -0.23h1.79a0.49 0.49 0 0 0 0.49 -0.49V14.1a5.44 5.44 0 1 0 -10.88 0v3.47a0.49 0.49 0 0 0 0.45 0.49Z"
                fill="currentColor"
                strokeWidth="1"
              />
              <path
                d="M16.7 0a4.21 4.21 0 1 0 4.21 4.2A4.21 4.21 0 0 0 16.7 0Zm0 6.43a2.22 2.22 0 0 1 -2.22 -2.23 2.06 2.06 0 0 1 0.15 -0.79 0.28 0.28 0 0 1 0.15 -0.15 0.26 0.26 0 0 1 0.21 0 5.32 5.32 0 0 0 2.8 0.79 5.29 5.29 0 0 0 0.9 -0.08 0.18 0.18 0 0 1 0.16 0 0.19 0.19 0 0 1 0.08 0.15 2.23 2.23 0 0 1 -2.23 2.31Z"
                fill="currentColor"
                strokeWidth="1"
              />
              <path
                d="M7.3 0a4.21 4.21 0 1 0 4.2 4.2A4.21 4.21 0 0 0 7.3 0Zm0 6.43A2.23 2.23 0 0 1 5.07 4.2a2.06 2.06 0 0 1 0.16 -0.79 0.28 0.28 0 0 1 0.15 -0.15 0.26 0.26 0 0 1 0.21 0 5.32 5.32 0 0 0 2.8 0.79 5.38 5.38 0 0 0 0.9 -0.05 0.18 0.18 0 0 1 0.16 0 0.18 0.18 0 0 1 0.07 0.15A2.22 2.22 0 0 1 7.3 6.43Z"
                fill="currentColor"
                strokeWidth="1"
              />
            </svg>
          )}
        </button>
        {(adults > 1 || kids > 0 || dogs > 0) && (
          <button
            type="button"
            className="absolute right-3 top-5 text-brandcopy-700 hover:text-brandcopy-900 transition-all duration-150 ease-in-out"
            onClick={() => {
              setAdults(1);
              setKids(0);
              setDogs(0);
            }}
          >
            <span className="sr-only">
              {global.Translator.trans("locationform.guests_reset", {}, "js")}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-4"
            >
              <path
                fill-rule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
